module.exports = __webpack_public_path__ + "static/media/AX320.4d3efb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AX320.jpg
// module id = 1072
// module chunks = 0